module.exports = __webpack_public_path__ + "img/gkoutsidis.e5c6b618.jpg";